import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("dgnbp"), parcelRequire.load("j2VIL"), parcelRequire.load("g56vt"), parcelRequire.load("lzjui"), parcelRequire.load("jqxBu"), parcelRequire.load("3YuHm"), parcelRequire.load("8WlTG"), parcelRequire.load("d4VSw"), parcelRequire.load("hCFJT"), parcelRequire.load("3wDhD"), parcelRequire.load("lH05e"), parcelRequire.load("45RYB"), parcelRequire.load("6ZqMg"), parcelRequire.load("dRxJe")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("dgnbp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("j2VIL")} />
  <link rel="modulepreload" href={parcelRequire.resolve("g56vt")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lzjui")} />
  <link rel="modulepreload" href={parcelRequire.resolve("jqxBu")} />
  <link rel="modulepreload" href={parcelRequire.resolve("3YuHm")} />
  <link rel="modulepreload" href={parcelRequire.resolve("8WlTG")} />
  <link rel="modulepreload" href={parcelRequire.resolve("d4VSw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("hCFJT")} />
  <link rel="modulepreload" href={parcelRequire.resolve("3wDhD")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lH05e")} />
  <link rel="modulepreload" href={parcelRequire.resolve("45RYB")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6ZqMg")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dRxJe")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
